import { render } from "./AffiliationPage.vue?vue&type=template&id=1725f110"
import script from "./AffiliationPage.vue?vue&type=script&lang=ts"
export * from "./AffiliationPage.vue?vue&type=script&lang=ts"
script.render = render

export default script